/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TunnelAdminListItem } from './TunnelAdminListItem';
import {
    TunnelAdminListItemFromJSON,
    TunnelAdminListItemFromJSONTyped,
    TunnelAdminListItemToJSON,
    TunnelAdminListItemToJSONTyped,
} from './TunnelAdminListItem';

/**
 * 
 * @export
 * @interface GetTunnelAdminListResponse
 */
export interface GetTunnelAdminListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTunnelAdminListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<TunnelAdminListItem>}
     * @memberof GetTunnelAdminListResponse
     */
    items: Array<TunnelAdminListItem>;
}

/**
 * Check if a given object implements the GetTunnelAdminListResponse interface.
 */
export function instanceOfGetTunnelAdminListResponse(value: object): value is GetTunnelAdminListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetTunnelAdminListResponseFromJSON(json: any): GetTunnelAdminListResponse {
    return GetTunnelAdminListResponseFromJSONTyped(json, false);
}

export function GetTunnelAdminListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTunnelAdminListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(TunnelAdminListItemFromJSON)),
    };
}

export function GetTunnelAdminListResponseToJSON(json: any): GetTunnelAdminListResponse {
    return GetTunnelAdminListResponseToJSONTyped(json, false);
}

export function GetTunnelAdminListResponseToJSONTyped(value?: GetTunnelAdminListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(TunnelAdminListItemToJSON)),
    };
}

